import React, { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Markdown } from 'components/Markdown'
import styles from './PrivacyPolicy.module.scss'

export const PrivacyPolicy: FC = () => {
  var { i18n } = useTranslation()
  const navigate = useNavigate()
  const [mdText, setMdText] = useState('')

  try {
    if (typeof i18n.language == 'undefined') {
      i18n.language = 'es'
    }
  } catch (e) {
    console.log(e);
  }

  useEffect(() => {
    fetch(`/files/privacy-policy.${i18n.language}.md`)
      .then((res) => (res.ok ? res.text() : Promise.reject()))
      .then(setMdText)
      .catch(() => navigate('/'))
  }, [i18n.language, navigate])

  return (
    <div className={styles.privacyPolicy}>
      <Markdown source={mdText} />
    </div>
  )
}

PrivacyPolicy.displayName = 'PrivacyPolicy'
